import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import template from '../../templates/FeatureInclusion/AddAssignee.rt';
import * as actions from '../../actions';

function mapStateToProps(state, props) {
  const PAGE_SIZE = 5;
  const { selectedPreset, featureInclusionData, assign_page, assign_term, customers, assign_checked } = state.featureInclusion;
  let preset = featureInclusionData[_.findIndex(featureInclusionData, (f) => { return f.id == selectedPreset; })];
  let customerList = customers || [];
  customerList.sort((a, b) => {
    let aName = _.trim(a.name).toLowerCase()
      , bName = _.trim(b.name).toLowerCase();

    if(aName < bName) {
      return -1;
    } else if (aName > bName) {
      return 1;
    }
    return 0;
  });
  let filteredCustomers = customerList;
  if(_.trim(assign_term).length > 0) {
    filteredCustomers = _.filter(customerList, (c) => {
      return _.includes(_.trim(c.name).toLowerCase(), _.trim(assign_term).toLowerCase());
    });
  }
  let pagedFilteredCustomers = _.chunk(filteredCustomers, PAGE_SIZE);
  let totalPages = pagedFilteredCustomers.length;
  return {
    searchTerm: assign_term,
    pagedCustomers: pagedFilteredCustomers[assign_page],
    selectedPreset: preset,
    totalPages,
    page: assign_page,
    checked: assign_checked
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    loadCustomers: () => dispatch(actions.featureInclusion.loadCustomers()),
    setPage: (page) => dispatch(actions.featureInclusion.setAssigneePage(page)),
    setSearchTerm: (term) => dispatch(actions.featureInclusion.setAssigneeSearchTerm(term)),
    saveAddAssignees: () => dispatch(actions.featureInclusion.saveAssignees()),
    setAssigneeChecked: (id) => dispatch(actions.featureInclusion.checkAssignee(id)),
    hideAddAssigneePopup: () => dispatch(actions.featureInclusion.showAddAssigneePopup(false))
  };
}

class addAssignee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: props.page
    };
  }
  componentWillMount() {
    this.props.loadCustomers();
  }
  render = template;

  setPage = (page) => {
    this.setState({page: page}, () => this.props.setPage(page));
  }

  isChecked = (id) => {
    return (_.indexOf(this.props.checked, id) >= 0);
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
const AddAssignee = connector(addAssignee);

export { AddAssignee }
export default AddAssignee;
